import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { getMembershipPlans, updateMembershipPlan } from '../services/api';
import './Membership.css';

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
);

const DEFAULT_PLANS = [
  { id:'basic',      name:'Basic',      price:0,   billing:'monthly', features:['Up to 100 contacts','1 pipeline','Email sequences (3)','Basic reporting'] },
  { id:'pro',        name:'Pro',        price:49,  billing:'monthly', features:['Up to 2,000 contacts','3 pipelines','Email sequences (unlimited)','Advanced reporting','API access'] },
  { id:'enterprise', name:'Enterprise', price:199, billing:'monthly', features:['Unlimited contacts','Unlimited pipelines','Email sequences (unlimited)','Custom reporting','API access','Priority support','Custom integrations'] },
];

export default function Membership() {
  const { token, toast } = useApp();
  const [plans, setPlans]       = useState(DEFAULT_PLANS);
  const [current, setCurrent]   = useState('enterprise');
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    getMembershipPlans(token)
      .then(res => { if (res.data?.length) setPlans(res.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  const upgrade = async (planId) => {
    if (planId === current) return;
    try {
      toast?.(`Switching to ${plans.find(p=>p.id===planId)?.name} plan…`);
      setCurrent(planId);
    } catch (e) { toast?.(e.message, 'error'); }
  };

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:500, color:'var(--text-primary)', marginBottom:4 }}>Membership & Billing</h2>
        <p style={{ fontSize:13, color:'var(--text-muted)' }}>Current plan: <strong style={{color:'var(--accent)'}}>{plans.find(p=>p.id===current)?.name}</strong></p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginBottom:32 }}>
        {plans.map(plan => (
          <div key={plan.id} className="card" style={{ borderColor: current===plan.id ? 'var(--accent)' : undefined, position:'relative' }}>
            {current === plan.id && (
              <div style={{ position:'absolute', top:-1, right:-1, background:'var(--accent)', color:'#0a0a0a', fontSize:10, fontWeight:700, padding:'3px 10px', borderRadius:'0 var(--radius-md) 0 8px' }}>CURRENT</div>
            )}
            <div style={{ marginBottom:12 }}>
              <div style={{ fontWeight:600, fontSize:16, color:'var(--text-primary)', marginBottom:4 }}>{plan.name}</div>
              <div style={{ fontSize:24, fontWeight:700, color:'var(--accent)' }}>
                {plan.price === 0 ? 'Free' : `$${plan.price}`}
                {plan.price > 0 && <span style={{ fontSize:13, fontWeight:400, color:'var(--text-dim)' }}>/mo</span>}
              </div>
            </div>
            <div style={{ marginBottom:16 }}>
              {(plan.features || []).map((f,i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, fontSize:12, color:'var(--text-muted)' }}>
                  <span style={{ color:'var(--accent)' }}><CheckIcon /></span>{f}
                </div>
              ))}
            </div>
            <button
              className={current===plan.id ? 'btn btn-ghost' : 'btn btn-primary'}
              style={{ width:'100%', fontSize:12 }}
              onClick={() => upgrade(plan.id)}
              disabled={current===plan.id}
            >
              {current===plan.id ? 'Current plan' : plan.price === 0 ? 'Downgrade' : 'Upgrade'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
